import React from 'react';
import { Button, DatePicker, Form, Input, Switch } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { openNotification, extractApiErrorMessage, toTurkishUpper } from '../../../utils';
import { createPublicHoliday, updatePublicHoliday, getPublicHoliday } from '../services/public-holidayService';
import { CreatePublicHolidayDto } from '../types/PublicHoliday';

const { RangePicker } = DatePicker;

type FormValues = CreatePublicHolidayDto & { dateRange?: [Dayjs | null, Dayjs | null] };

export default function PublicHolidayForm({ id, onSuccess }: { id?: number; onSuccess: () => void }) {
  const [form] = Form.useForm<FormValues>();

  React.useEffect(() => {
    if (id) {
      getPublicHoliday(id).then(data => {
        const values: FormValues = {
          name: data?.name ?? '',
          startDate: data?.startDate,
          endDate: data?.endDate,
          halfDay: data?.halfDay ?? false,
          dateRange:
            data?.startDate && data?.endDate
              ? [dayjs(data.startDate), dayjs(data.endDate)]
              : undefined,
        };
        form.setFieldsValue(values);
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ halfDay: false });
    }
  }, [id, form]);

  const onFinish = async (values: FormValues) => {
    const payload: CreatePublicHolidayDto = {
      name: toTurkishUpper(values.name)?.trim() ?? '',
      startDate: values.dateRange?.[0]?.format('YYYY-MM-DD') ?? values.startDate,
      endDate: values.dateRange?.[1]?.format('YYYY-MM-DD') ?? values.endDate,
      halfDay: values.halfDay ?? false,
    };

    try {
      if (id) {
        await updatePublicHoliday(id, payload);
        openNotification('success', 'Başarılı', 'Resmi Tatil Güncellendi');
      } else {
        await createPublicHoliday(payload);
        openNotification('success', 'Başarılı', 'Resmi Tatil Eklendi');
      }
      onSuccess();
    } catch (e) {
      const message = extractApiErrorMessage(e, 'Resmi Tatil işlemi başarısız');
      openNotification('error', 'Hata', message);
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout='vertical'>
      <Form.Item name='name' label='Resmi Tatil Adı' rules={[{ required: true, message: 'Resmi tatil adını giriniz' }]}>
        <Input style={{ width: '100%', textTransform: 'uppercase' }} lang='tr' />
      </Form.Item>
      <Form.Item
        name='dateRange'
        label='Tarih Aralığı'
        rules={[{ required: true, message: 'Başlangıç ve bitiş tarihlerini seçiniz' }]}
      >
        <RangePicker style={{ width: '100%' }} format='DD/MM/YYYY' />
      </Form.Item>
      <Form.Item name='halfDay' label='Tam Gün / Yarım Gün' valuePropName='checked'>
        <Switch checkedChildren='Yarım Gün' unCheckedChildren='Tam Gün' />
      </Form.Item>
      <Button htmlType='submit' type='primary' block>
        Kaydet
      </Button>
    </Form>
  );
}
